import Button from "common/Button";
import FormFields from "components/Form";
import React, { useState } from "react";
import styles from "./admin.module.css";
import Toast from "utils";
import axios from "axios";
import SubAdminManager from "components/Setting/SubAdminManager";
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

const Admin = () =>{
    const auth = useAuthUser();
    const authHeader = useAuthHeader();
    
  const [email, setEmailChange] = useState(null);


  const handleSettingsChange = (label) => {
    return (e) => {

      setEmailChange(   e.target.value );
    };
  };



    const AdminFields = [
        {
          label: "Email",
          id: "email",
          placeholder: "Enter Email",
          type: "email",
          value: email,
          required: true,
          onChange: handleSettingsChange("email"),
        },
      ];


    const handleAddAdmin = async (e) => {
        e?.preventDefault();
        try {
          const response = await axios.post(
            `http://localhost:3000/admin`,
            {
              email,
            }     ,
               {
              headers: {
                Authorization: authHeader // Use authHeader from react-auth-kit
              }
            },
          );
          if (response?.data?.success) {
            // Toast().Success(response?.data?.message);
            Toast().Success("You have been sent an invite to your email");
            // navigate(`/reset-password?email=${email}&token=${response?.data?.token}`);
          }
        } catch (error) {
          Toast().Error("Failed to add admin. Please try again.");
          // Toast().Error(
          //   error?.response?.data?.message ||
          //     error?.response?.data?.errors?.[0]?.msg
          // );
        }
    
    
    };
 

    return <>
             {/* Add Admin Form - Temporarily Hidden */}
             {/* <form onSubmit={handleAddAdmin}>
              <FormFields Fields={AdminFields} />
              <div className={styles.addAdminContainer}>
                <Button label="Add Admin" type="submit"  >
                  Add Admin
                </Button>
              </div>
            </form>

            <div style={{ 
              height: '1px', 
              background: '#dcdce5', 
              margin: '4rem 0',
              opacity: 0.6 
            }} /> */}

            {/* Sub-Admin Management Section */}
            <SubAdminManager 
              adminId={auth?.id}
              authToken={authHeader?.replace('Bearer ', '')}
            />
    </>
}

export default Admin;